import type { FC } from "react";

import { ECategoryReferralsType } from "app/pages/website-analysis/website-structure/pages/ReferralsWrapper";
import { WWOTopLinkDestinationsTable } from "app/pages/website-performance/components/TopLinkDestinations/WWOTopLinkDestinationsTable";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTopLinkDestinationsContainerDS: FC = () => {
    const params = proNavigator.getParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("digitalsuite_website_referrals_outgoingtraffic", {
                ...params,
                selectedTab: ECategoryReferralsType.OutgoingTraffic,
            }),
            target: "_self",
        };
    };
    return (
        <WWOTopLinkDestinationsTable
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WebReferralOutgoingTraffic",
                hookModal: "referrals",
            }}
        />
    );
};
